module.exports = __webpack_public_path__ + "static/media/logoName.d37b489a.svg";